(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('formSubmit', function(
    $rootScope,
    scrollService,
    $timeout,
    analytics,
    $routeParams,
    tripService,
    resourceService) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            isDisabled: '=',
            inputClass: '@',
            form: '=',
            click: '&',
            model: '=',
            label: '@',
            scroll: '=',
            preFlight: '&',
            templateVersion: '='
        },
        templateUrl: (element, attr) => attr.templateVersion ?
            `partials/booking/template?name=FormSubmit&version=${attr.templateVersion}` :
            'partials/home/directivetemplate?type=FormSubmit',
        link(scope, element, attrs) {
            let noClass = (scope.inputClass || '').replace(/ /g, '').length <= 0;
            scope.buttonClass = noClass ? 'button primary' : scope.inputClass;

            function onClick(event) {
                $rootScope.submittedForm = null;
                if (!scope.form.$valid) {
                    $rootScope.submittedForm = scope.form;
                    $rootScope.$broadcast('form:submitted-invalid', scope.form);
                    //wrap in timeout to allow time for address search field to reveal itself
                    $timeout(function() {
                        const form = $(element).parents('form');
                        const selectors = '.tokenising-field.ng-invalid:visible,' +
                            '.dob-picker.ng-invalid select:visible,' +
                            'input.ng-invalid:visible,' +
                            'select.ng-invalid:visible,' +
                            'div.ng-invalid .driver-type-select:visible,' +
                            'div.checkbox-btn.ng-invalid:visible,' +
                            'label.checkbox-btn.ng-invalid:visible,' +
                            '.pseudo-input.ng-invalid:visible,' +
                            'textarea.ng-invalid:visible,' +
                            'date-picker.ng-invalid .hasDatepicker:visible,' +
                            'div.ng-invalid input:visible';

                        //check if we have a closer isolated ng-form, if so pick the next element
                        let target = null;
                        const elements = $(selectors, form);
                        if (form.length > 0) {
                            _.each(elements, i => {
                                let ngForm = $(i).closest('ng-form')[0] || null;
                                if (!ngForm || !$(ngForm).hasClass('isolated-form')) {
                                    target = $(i);
                                    return false;
                                }
                            });
                        } else {
                            target = $(selectors).first();
                        }

                        if (scope.scroll) {
                            scrollService.scrollTo(target, { animate: true, offset: 100 })
                                .then(() => target.focus());
                        } else {
                            target.focus();
                        }
                    });
                    setTimeout(() => analytics.track('mixpanel', 'FormValidation', { form: scope.form }));
                    return;
                }
                scope.click({ model: scope.model, event });
            }

            scope.$click = function(event) {
                const res = scope.preFlight && scope.preFlight();
                if (res) {
                    scope.disabled = true;
                    res.then(() => $timeout(() => {
                        scope.disabled = false;
                        onClick(event);
                    })).catch(() => scope.disabled = false);
                } else {
                    onClick(event);
                }
            };

            if (attrs.templateVersion) {
                tripService.getTrip($routeParams.tripId)
                    .then(trip => {
                        let tripType = _.findKey(tripService.tripTypes, o => o === trip.TripType);
                        tripType = (tripType || '').toUpperCase();
                        scope.labelForJourney = resourceService.get(`FORMSUBMITBUTTON_TRIPTYPE_${tripType}`);
                    })
                    .catch(angular.noop)
                    .then(() => {
                        if (!scope.labelForJourney || scope.labelForJourney.indexOf('FORMSUBMITBUTTON') > -1) {
                            scope.labelForJourney = resourceService.get('FORMSUBMITBUTTON_TRIPTYPE_NONE');
                        }
                    });
            }
        }
    };
});
})();
